import { render, staticRenderFns } from "./AdminAccountTable.vue?vue&type=template&id=d480fd88&scoped=true"
import script from "./AdminAccountTable.vue?vue&type=script&lang=js"
export * from "./AdminAccountTable.vue?vue&type=script&lang=js"
import style0 from "./AdminAccountTable.vue?vue&type=style&index=0&id=d480fd88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d480fd88",
  null
  
)

export default component.exports